import React, { Component } from 'react';

import { AgGridReact } from "@ag-grid-community/react";
import { Loader } from 'semantic-ui-react';
import { ACTION_STATUS } from '../../../../../utils/ActionStatus';
import '../../ComplianceRule.css';

class PBShortInterestRateGrid extends Component {

  constructor(props) {
    super(props);

    this.state = {
      columnDefs: props.pbShortInterestRateGridColumns,
      defaultColDef: {
        enableCellChangeFlash: true,
        // minWidth: 30
      },
      rowSelection: "multiple",
    };
  }

  onGridReady = params => {
    this.gridApi = params.api;
    this.columnApi = params.columnApi;

    // const COLUMNS_KEY = 'fund-list-grid-col-state';

    // StateSynchronizer.syncGrid(
    //   params,
    //   this.state.columnDefs,
    //   () => localStorageClient.getGridColumnState(COLUMNS_KEY),
    //   s => localStorageClient.saveGridColumnState(COLUMNS_KEY, s)
    // );
  };

  render() {
    const {
      pbShortInterestRateArray,
      className = 'grid-wrapper',
      loadPBShortInterestRateActionStatus,
    } = this.props;

    const isLoading = loadPBShortInterestRateActionStatus === ACTION_STATUS.LOGINING;
    if (loadPBShortInterestRateActionStatus === ACTION_STATUS.SUCCESS) {
      this.props.initLoadPBShortInterestRateActionStatus();
    }

    return (
      <div className={`ag-theme-balham ${className}`}>
        {isLoading ? (
            <Loader active content="Loading..." />
          ) : (
          <AgGridReact
            // properties
            columnDefs={this.state.columnDefs}
            rowData={pbShortInterestRateArray}
            defaultColDef={this.state.defaultColDef}
            rowSelection={this.state.rowSelection}
            enableSorting={true}
            enableFilter={true}
            animateRows={true}
            deltaRowDataMode={false}
            enableColResize={true}
            getRowNodeId={this.getRowNodeId}
            // events
            onGridReady={this.onGridReady}
            onSelectionChanged={this.onSelectionChanged}
          />
        )}
      </div>
    );
  }
}

export default PBShortInterestRateGrid;